import {
  Vendor,
  VendorDashboardCounts,
  VendorListItem,
  VendorListParams,
  VendorPartnerListParams,
} from '../models/vendor-management-row';
import { PartnerListItem } from '../../partner-management/models/partner-management';

export interface VendorManagementState {
  rows: VendorListItem[];
  counts: VendorDashboardCounts;
  totalVendors: number;
  loadingList: boolean;
  loadingDetail: boolean;
  submitting: boolean;
  error: string | null;
  listError: string | null;
  successMessage: string | null;
  selectedVendor: Vendor | null;
  selectedVendorId: string | null;
  vendorPartnerRows: PartnerListItem[];
  vendorPartnerTotal: number;
  loadingVendorPartners: boolean;
  vendorPartnerError: string | null;
  vendorPartnerPage: number;
  vendorPartnerPageSize: number;
  vendorPartnerParams: VendorPartnerListParams | null;
  currentPage: number;
  pageSize: number;
  listParams: VendorListParams | null;
}

export const initialVendorManagementState: VendorManagementState = {
  rows: [],
  counts: {
    all_vendors: 0,
    active_vendors: 0,
    inactive_vendors: 0,
  },
  totalVendors: 0,
  loadingList: false,
  loadingDetail: false,
  submitting: false,
  error: null,
  listError: null,
  successMessage: null,
  selectedVendor: null,
  selectedVendorId: null,
  vendorPartnerRows: [],
  vendorPartnerTotal: 0,
  loadingVendorPartners: false,
  vendorPartnerError: null,
  vendorPartnerPage: 1,
  vendorPartnerPageSize: 10,
  vendorPartnerParams: null,
  currentPage: 1,
  pageSize: 10,
  listParams: null,
};
